import { useMemo } from "react"

import { useHelmet } from "./useHelmet"

export function useTitle(title: string | undefined) {
  const memoizedAttributes = useMemo(
    () => ({
      title
    }),
    [title]
  )
  useHelmet(memoizedAttributes)
}
